import { Checkpoint } from './state';

export type SelectedAction = {
  type: 'add' | 'remove',
  values: Checkpoint[]
} | {
  type: 'toggle'
  value: Checkpoint
} | {
  type: 'clear'
};

export const checkpointSelectionReducer = (state: Map<string, Checkpoint>, action: SelectedAction) => {
  const newState = new Map(state);
  switch (action.type) {
    case 'add':
      action.values.forEach(c => newState.set(c.code, c));
      break;
    case 'remove':
      action.values.forEach(c => newState.delete(c.code));
      break;
    case 'clear':
      newState.clear();
      break;
    case 'toggle':
      newState.has(action.value.code) ?
        newState.delete(action.value.code) :
        newState.set(action.value.code, action.value);
      break;
    default:
      throw new Error();
  }
  return newState;
};
